import { useEffect } from 'react';

import { BoardSteps } from 'utils/constants';
import { unMaskInputValue } from 'utils/helpers';
import { useNextHandler } from 'features/Croptimizer/providers/NextHandlerContext';
import { scrollTop } from 'utils/scroll-top';
import { useCroptimizer } from 'features/Croptimizer/providers/CroptimizerContext';

export const useFertilizationNavigation = (
  isActive: boolean,
  cleaninputn: string,
  cleaninputp: string,
  cleaninputk: string,
  cleanpricesn: string,
  cleanpricesp: string,
  cleanpricesk: string,
  efficiencyN: string,
  efficiencyP: string,
  efficiencyK: string,
) => {
  const { setStep, setFertilizationValues } = useCroptimizer();
  const { setHandler, setShowBack, setBackHandler, setShowNext } = useNextHandler();

  const handleNextStep = () => {
    setStep(BoardSteps.mineralization);
  };

  const handleBackStep = () => {
    setStep(BoardSteps.crop);
    scrollTop();
  };

  useEffect(() => {
    // When active, configure navigation buttons
    // and define the "Next" handler to update board state and trigger status handling
    if (!isActive) {
      return;
    }

    setShowBack(true);
    setShowNext(true);
    setBackHandler(handleBackStep);

    setHandler(() => {
      setFertilizationValues({
        nvalue: unMaskInputValue(String(cleaninputn)),
        pvalue: unMaskInputValue(String(cleaninputp)),
        kvalue: unMaskInputValue(String(cleaninputk)),
        nprice: unMaskInputValue(String(cleanpricesn)),
        pprice: unMaskInputValue(String(cleanpricesp)),
        kprice: unMaskInputValue(String(cleanpricesk)),
        efficiencyN: unMaskInputValue(String(efficiencyN)),
        efficiencyP: unMaskInputValue(String(efficiencyP)),
        efficiencyK: unMaskInputValue(String(efficiencyK)),
      });

      handleNextStep();

      scrollTop();
    });
  }, [
    isActive,
    cleaninputn,
    cleaninputp,
    cleaninputk,
    cleanpricesn,
    cleanpricesp,
    cleanpricesk,
    efficiencyN,
    efficiencyP,
    efficiencyK,
    setHandler,
    setShowBack,
    setShowNext,
    setBackHandler,
    setFertilizationValues,
  ]);

  return {
    handleNextStep,
    handleBackStep,
  };
}; 